<template>
  <div class="app-content ap trash">
    <b-row class="row mb-4">
      <b-col cols="auto">
        <b-button @click="$router.go(-1)" class="btn btn-secondary btn-svg" title="Back to Monitor"><svg viewBox="0 0 492 492"><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></svg></b-button>
      </b-col>
      <b-col>
        <div class="d-flex h-100 w-100 flex-column justify-content-center">
          <h1 class="ap__main-title text-danger mb-2">{{ monitorCategory }} Insight Monitors</h1>
          <h5 class="font-weight-bold mb-0" v-if="currentTag">{{ currentTag.generation }} → History</h5>
        </div>
      </b-col>
    </b-row>

    <template v-if="isLoading">
      <div class="d-flex flex-column justify-content-center text-center align-items-center app__loading">
        <p><strong>Loading data...</strong></p>
        <b-spinner></b-spinner>
      </div>
    </template>
    <template v-else>
      <table class="table trash__table" v-if="historyList.length">
        <thead>
          <tr>
            <th>Date</th>
            <th>User</th>
            <th>Object</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(action, index) in historyList" :key="index">
            <td class="trash__item-date">{{ action.date }}</td>
            <td>{{ action.user }}</td>
            <td>{{ action.obj }}</td>
            <td v-html="action.obj_descr"></td>
            <td>{{ action.action }}</td>
          </tr>
        </tbody>
      </table>
      <b-card
        v-else
        tag="article"
        class="text-center mb-3"
      >
        <b-card-text>
          The history is empty
        </b-card-text>
      </b-card>
    </template>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { monitorsDataMixin } from '../mixins/monitorsDataMixin.js';

import {
  GLOBAL_CHANGE_SECTION,
  MONITOR_HISTORY_GET
} from "@/store/actions.type";

export default {
  name: 'MonitorsHistory',
  mixins: [monitorsDataMixin],
  data() {
    return {
      isLoading: true,
      tagId: null,
      historyList: []
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "section", "monitorCategory", "monitorCurrent"]),
    currentTag: function() {
      let filteredTags = this.monitorConsumerGenerations.filter(i => i.id === this.tagId)
      return filteredTags[0];
    }
  },
  methods: {
    getMonitorsHistory() {
      this.$store.dispatch(MONITOR_HISTORY_GET, this.tagId).then((data) => {
        this.historyList = data;
        this.isLoading = false;
      });
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    if(this.section != 'monitors') {
      this.$store.dispatch(GLOBAL_CHANGE_SECTION, 'monitors');
      this.getMonitorsData();
    }

    this.tagId = this.$route.params.tagId;
    this.getMonitorsHistory();
  }
}
</script>

<style lang="scss">
  
</style>